const cookie = {
  get(name){
    if(!name){
      return undefined;
    }

    const cookiesArr = document.cookie.split(';');
    for(var i=0; i<cookiesArr.length; i++){
      const cookieName = cookiesArr[i].substring(0, cookiesArr[i].indexOf('=')).trim();
      if(cookieName === name){
        const cookieValue = cookiesArr[i].substring(cookiesArr[i].indexOf('=') + 1);
        return cookieValue;
      }
    }

    return '';
  },

  /*

  set(name, value, expires){
  },

  delete(name){
  },

  */
};

export default cookie;
